import lazyLoading from './lazyLoading'
export default (routers,data) => {

  generaMenu(routers,data)
  return routers
}
function generaMenu(routers,data){
    data.forEach((item)=>{
        let menu = Object.assign({},item)
        if(menu.parentId==0){
            menu.component=() => import('@/page/layout/main.vue');
            
        }else{
            menu.component = lazyLoading(menu.component)
        }
        
        if(item.children){
            menu.children = []
            generaMenu(menu.children,item.children)
        }
        routers.push(menu)
    })
}


// WEBPACK FOOTER //
// ./src/utils/MenuUtils.js